import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useIntl } from 'react-intl'
import { useDayJsLocale } from '../../hooks/useDayJsLocale'

const DateLocaleProvider = ({ children }) => {
	const { locale: localeContext } = useIntl()
	const locale = useDayJsLocale(localeContext)

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
			{children}
		</LocalizationProvider>
	)
}

export default DateLocaleProvider
